import type { Color, IGraphSizes, IPosition } from '../helpers';
import { getColorCode, getCoordinates } from '../helpers';

interface IElipseProps {
    borderColor: Color;
    borderWidth: number;
    fillColor: Color;
    graphSizes: IGraphSizes;
    position: IPosition;
}

export function Ellipse(props: IElipseProps) {
    const { fillColor, borderColor, position, graphSizes, borderWidth } = props;
    const coordinates = getCoordinates(position, graphSizes);

    return (
        <ellipse
            cx={coordinates.x + graphSizes.nodeWidth / 2}
            cy={coordinates.y + graphSizes.nodeHeight / 2}
            fill={fillColor ? getColorCode(fillColor) : undefined}
            rx={graphSizes.nodeWidth / 2}
            ry={graphSizes.nodeHeight / 2}
            stroke={getColorCode(borderColor)}
            strokeWidth={borderWidth}
        />
    );
}
